module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("hou that hast given so much to me,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Give one thing more, a grateful heart.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Not thankful when it pleaseth me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("As if thy blessings had spare days;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("But such a heart, whose pulse may be thy praise.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("N")]), _vm._v("ow may every living thing, young or old, weak or strong, living near or far, known or unknown, living or departed or yet unborn, may every living thing be full of bliss.")], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('big', [_vm._v("H")]), _vm._v("ow easily we can forget how precious life is! So long as we can remember, we've just been here, being alive. Unlike other things for which we have a comparison— black to white, day to night, good to bad—we are so immersed in life that we can see it only in the context of itself. We don't see life as compared to anything, to not-being, for example, to never having been born. Life just is.")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("But life itself is a gift. It's a compliment just being born: to feel, breathe, think, play, dance, sing, work, make love, for this particular lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Today, let's give thanks for life. For life itself! For simply being born!")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('big', [_vm._v("M")]), _vm._v("y whole being pulsates")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("with the fire of desire")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("for our everlasting union.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My very breath is but Yours.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("My heart is a limitless beacon")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("of Your Love.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My Spirit, being Yours,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("is the light of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("My eyes but radiate and reflect")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("our Perfect Love.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My very essence vibrates with You")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("as the harmony of music")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("not yet heard.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My vision is but Your Love")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("flowing through me,")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("seeing only its own reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My only fulfillment is following Your")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Directions and Guidance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My voice, being Yours,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("can only bless.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My prayer is but an eternal song of gratitude,")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("and I am in You,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And that I live in Your Grace")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("forever.")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("Y")]), _vm._v("ou who are smaller than the smallest seed; more beautiful than the rarest gem; Who hold the mountains and oceans in Your hand; Who breathes us with the breath of life; enfold us in Your great love that we may open our hearts to all mankind.")], 1), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('big', [_vm._v("G")]), _vm._v("reat Spirit, who hast blessed the earth that it should be fruitful and bring forth whatsoever is needful for the life of man, and hast commanded us to work with quietness, and eat our own bread; Bless the labors of those who till the fields and grant such seasonable weather that we may gather in the fruits of the earth.")], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("T")]), _vm._v("oday, today, today. Bless us . . .")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and help us to grow.")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("he Inner Light is beyond both praise and blame,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Like unto space it knows no boundaries;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Yet it is right here with us,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("ever retaining its serenity and fullness.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It is only when you seek it that you lose it.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You cannot take hold of it nor can you get rid of it;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("While you can do neither, it goes on its own way.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You remain silent and it speaks;")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("you speak and it is silent.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The Gate of Heaven is wide open")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("with not a single obstruction before it.")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("e join with the earth and with each other")], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To bring new life to the land")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To restore the waters")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To refresh the air")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To renew the forests")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To care for the plants")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To protect the creatures")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We join with the earth and with each other")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To celebrate the seas")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To rejoice in the sunlight")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To sing the song of the stars")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We join with the earth and with each other")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To recreate the human community")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To promote justice and peace")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To remember our children")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We join with the earth and with each other")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We join together as many and diverse expressions")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("of one loving memory: for the healing of the")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("earth and the renewal of all life.")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("A")]), _vm._v(" bright autumn moon . . .")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In the shadow of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("each grass")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("an insect chirping")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("he Lord is my shepherd, I shall not want. She maketh me to lie down in green pastures. She leadeth me beside the still waters. She restoreth my soul. She leadeth me in the paths of righteousness for her name's sake. Yea, though I walk through the valley of the shadow of death, I will fear no evil; for thou art with me; thy rod and thy staff, they comfort me. Thou preparest a table before me in the presence of mine enemies; thou anointest my head with oil; my cup runneth over. Surely goodness and mercy shall follow me all the days of my life; and I will dwell in the house of the Lord forever.")], 1), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("M")]), _vm._v("ay the blessing of light be on you, light without and light within. May the blessed sunshine shine on you and warm your heart till it glows like a great peat fire, so that the stranger may come and warm himself at it, and also a friend.")], 1), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("hen grapes turn")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to wine, they long for our ability to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When stars wheel")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("around the North Pole,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("they are longing for our growing consciousness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Wine got drunk with us,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("not the other way.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The body developed out of us, not we from it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We are bees,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and our body is a honeycomb.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We made")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the body, cell by cell we made it.")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('big', [_vm._v("B")]), _vm._v("lessed be you, harsh matter, barren soil, stubborn rock: you who yield only to violence, you who force us to work if we would eat. Blessed be you, perilous matter, violent sea, untameable passion: you who unless we fetter you will devour us. Blessed be you, mighty matter, irresistible march of evolution, reality ever new-born; you who, by constantly shattering our mental categories, force us to go ever further and further in our pursuit of the truth. Blessed be you, universal matter, unmeasurable time, boundless ether, triple abyss of stars and atoms and generations: you who by overflowing and dissolving our narrow standards of measurement reveal to us the dimensions of God . . .")], 1), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('big', [_vm._v("I")]), _vm._v(" salute the breath of life in thee, the same life that is breathed by me, warm flesh to warm flesh, oily press of nose to nose, the hardness of foreheads meeting. I salute that which gives us life.")], 1), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("H")]), _vm._v("ow do geese know when to fly to the sun? Who tells them the seasons? How do we, humans, know when it is time to move on? As with the migrant birds, so surely with us, there is a voice within, if only we would listen to it, that tells us so certainly when to go forth into the unknown.")], 1), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('big', [_vm._v("O")]), _vm._v(" Great Spirit,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Whose voice I hear in the winds,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And whose breath gives life to all the world,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("hear me! I am small and weak, I need your")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("strength and wisdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let Me Walk In Beauty, and make my eyes")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("ever behold the red and purple sunset.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Make My Hands respect the things you have")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("made and my ears sharp to hear your voice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Make Me Wise so that I may understand the")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("things you have taught my people.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let Me Learn the lessons you have hidden")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in every leaf and rock.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I Seek Strength, not to be greater than my")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("brother, but to fight my greatest enemy—myself.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Make Me Always Ready to come to you with")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("clean hands and straight eyes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("my spirit may come to you without shame.")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("H")]), _vm._v("elp us, O Lord, to remember our kindred beyond the sea—all those who bend in bonds, of our own blood and of human kind—the lowly and the wretched, the ignorant and the weak. We are one world . . . and one great human problem and what we do here goes to solve not only our petty troubles alone but the difficulties and desires of millions unborn and unknown. Let us then realize our responsibilities and gain strength to bear them worthily.")], 1), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('big', [_vm._v("L")]), _vm._v("et us bless and let us extol, let us tell aloud and let us raise aloft, let us set on high and let us honor, let us exalt and let us praise the Holy One—blessed be He!— though He is far beyond any blessing or song, any honor or any consolation that can be spoken of in this world.")], 1), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("O")]), _vm._v(" beloved Pan, and all the other deities of this place, grant that I may become beautiful in my soul within, and that all my external possessions may be in harmony with my inner self. May I consider the wise to be rich, and may I have such riches as only a person of self-restraint can bear or endure.")], 1), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('big', [_vm._v("G")]), _vm._v("randfather,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Look at our brokenness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We know that in all creation")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Only the human family")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Has strayed from the Sacred Way.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We know that we are the ones")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("who are divided")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And we are the ones")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Who must come back together")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To walk in the Sacred Way.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Grandfather,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Sacred One,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Teach us love, compassion, and honor")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("That we may heal the earth")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And heal each other.")]), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("e pray for the power to be gentle; the strength to be forgiving; the patience to be understanding; and the endurance to accept the consequences to holding to what we believe to be right.")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("May we put our trust in the power of good to overcome evil and the power of love to overcome hatred. We pray for the vision to see and the faith to believe in a world emancipated from violence, a new world where fear shall no longer lead men to commit injustice, nor selfishness make them bring suffering to others.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Help us to devote our whole life and thought and energy to the task of making peace, praying always for the inspiration and the power to fulfill the destiny for which we were created.")]), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('big', [_vm._v("H")]), _vm._v("oly Spirit,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("giving life to all life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("moving all creatures,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("root of all things,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("washing them clean,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("wiping out their mistakes,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("healing their wounds,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("you are our true life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("luminous, wonderful,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("awakening the heart")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("from its ancient sleep.")]), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('big', [_vm._v("A")]), _vm._v("ll Life Is One")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And Everything that Lives Is Holy")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Plants, Animals and People.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("All must eat to live and nourish one another")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We bless the lives that have died to give us this food.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let us eat together")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Resolving by our work to pay the debt of our existence.")]), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("M")]), _vm._v("ay suffering ones be suffering free")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And the fear struck fearless be.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May the grieving shed all grief—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And the sick find health relief.")]), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("e are all partakers of the bread of life,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Out of the lap of Mother Earth,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And from the hands of our human benefactors;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Many a life has been given for us,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Many a body has been broken for us,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We are all partakers of the water of life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Out of the springs and streams of the earth,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And of the blood of life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In uncounted sacrifices made in our behalf.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In ministrations such as these")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("hath God nourished us;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Freely we have received, freely let us give.")]), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('big', [_vm._v("P")]), _vm._v("raise wet snow")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("falling early.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Praise the shadow")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("my neighbor's chimney casts on the tile roof")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("even this gray October day that should, they say,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("have been golden.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Praise")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the invisible sun burning beyond")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("the white cold sky, giving us")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("light and the chimney's shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Praise")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("god or the gods, the unknown,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("that which imagined us, which stays")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("our hand,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("our murderous hand,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and gives us")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("still,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in the shadow of death,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("our daily life,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and the dream still")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("of goodwill, of peace on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Praise")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("flow and change, night and")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the pulse of day.")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('big', [_vm._v("L")]), _vm._v("ord of the World, I stand before you and before my neighbors—pardoning, forgiving, struggling to be open to all who have hurt and angered me. Be this hurt of body or soul, of honor or property, whether they were forced to hurt me or did so willingly, whether by accident or intent, whether by word or deed—I forgive them because we are human . . . I am ready to take upon myself the commandment, Love your neighbor as yourself.")], 1), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('big', [_vm._v("C")]), _vm._v("reator of the Stars")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("God of Epiphanies")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You are the Great Star")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You have marked my path with light")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You have filled my sky with stars")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("naming each star")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("guiding it")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("until it shines into my heart")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("awakening me to deeper seeing")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("new revelations")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and brighter epiphanies.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("O Infinite Star Giver")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I now ask for wisdom and courage")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("to follow these stars")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("for their names are many")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and my heart is fearful.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They shine on me wherever I go:")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("The Star of Hope")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("The Star of Mercy and Compassion")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("The Star of Justice and Peace")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("The Star of Tenderness and Love")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("The Star of Suffering")]), _vm._v(" "), _vm._m(49), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And every time I feel the shine")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("I am called")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("to follow it")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("to sing it")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("to live it . . .")]), _vm._v(" "), _vm._m(50), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("D")]), _vm._v("o all the good you can")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("By all the means you can")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In all the ways you can")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In all the places you can")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To all the people you can")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("As long as ever you can.")]), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('big', [_vm._v("D")]), _vm._v("o not think that love, in order to be genuine, has to be extraordinary. What we need is to love without getting tired.")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("How does a lamp burn? Through the continuous input of small drops of oil. If the drops of oil run out, the light of the lamp will cease, and the bridegroom will say, “I do not know you” (Matthew 25:12).")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("My daughters, what are these drops of oil in our lamps? They are the small things of daily life: faithfulness, punctuality, small words of kindness, a thought for others, our way of being silent, of looking, of speaking, and of acting. These are the true drops of love . . .")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Be faithful in small things because it is in them that your strength lies.")]), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('big', [_vm._v("M")]), _vm._v("ay our hearts be pure, harmonious and peaceful.")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May our Great Truth flourish and our worldly work")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("be prosperous and not offended by evil.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May all auspicious blessings be conferred.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May the benefits of yin and yang abundantly aid our")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("being and may we always be sheltered by Heaven.")]), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("“"), _c('big', [_vm._v("W")]), _vm._v("ithin each individual on this large and complicated world there lives an astonishing potential of greatness. Yet it is rare that these hidden gifts are brought to life unless by chance of fate,” writes Velma Wallis. Acknowledging the truth of this statement, we take the opportunity right now to ask ourselves what unrevealed gifts we have to offer the world. What in us is being called for? What can we give that we haven't been giving?")], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("L")]), _vm._v("earn to turn to each person as the most sacred person on Earth, to each moment as the most sacred moment that has ever been given to us. This moment may never happen again, because no two moments are ever alike. Are we perhaps awake a bit more, perhaps breathing together with God?")], 1), _vm._v(" "), _vm._m(57), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('big', [_vm._v("M")]), _vm._v("atthew Fox once wrote, “The only hope Mother Earth has for survival is our recovering creativity— which is of course, our divine power. Creativity is so satisfying, so important, not because it produces something but because the process is cosmological. There's joy and delight in giving birth.” Tonight we ask that each of us strive to tap into the creativity that is uniquely ours to give, and that we do so with a full measure of delight.")], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("M")]), _vm._v("ay we walk with grace")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and may the light of the universe")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("shine upon our path.")]), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('big', [_vm._v("Y")]), _vm._v("ou never enjoy the world aright till the sea itself flows in your veins, till you are clothed with the heavens, and crowned with the stars; and perceive yourself to be the sole heir of the whole world; and more than so, because men are in it who are every one sole heirs, as well as you . . .")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Till your spirit fills the whole world, and the stars are your jewels; till you are as familiar with the ways of God in all ages as with your walk and table; till you are intimately acquainted with that shady nothing out of which the world was made; till you love men so as to desire their happiness, with a thirst equal to the zeal of your own; till you delight in God for being good to all: you never enjoy the world . . .")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("You never enjoy the world aright till you see all things in it so perfectly yours that you cannot desire them any other way; and till you are convinced that all things serve you best in their proper places.")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("e are aware that all generations of our ancestors and all future generations are present in us.")], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We are aware of the expectations that our ancestors, our children, and their children have of us.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We are aware that our joy, peace, freedom, and harmony are the joy, peace, freedom, and harmony of our ancestors, our children, and their children.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We are aware that understanding is the very foundation of love.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We are aware that blaming and arguing never help us and only create a wider gap between us, that only understanding, trust, and love can help us change and grow.")]), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(62), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("rue greatness lies not always")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In the winning of worldly fame,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Nor doing our best spurred on by the cheers")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And plaudits that follow our name.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("But he who can face with a cheery grace")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The everyday of life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("With its petty things that rasp and sting,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Is a hero in the strife.")]), _vm._v(" "), _vm._m(63), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("T")]), _vm._v("he food is "), _c('i', [_vm._v("brahma")]), _vm._v(" (creative energy)")], 1), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("No sickness due to food can come")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To one who eats with this knowledge.")]), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('big', [_vm._v("H")]), _vm._v("ear a prayer for courage.")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Lord of the peaks,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Reared amid the thunders;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Keeper of the headlands")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Holding up the harvest,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Keeper of the strong rocks.")]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("M")]), _vm._v("ay the Ocean of Salt, the Ocean of")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Honey, the Ocean of Wine, the Ocean")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("of Ghee, the Ocean of Curd, the")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Ocean of Milk, the Ocean of Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Water sprinkle thee with their")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("consecrated waters.")]), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("hou Infinite One, it is Thy grace,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the highest opportunity for humanity")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("that we can sit and think and be together")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("to praise thee, O Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("O creative consciousness, O cosmos, moment of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("positive existence, positive relationship,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("positive love and brotherhood,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("dedicated unto this, the highest reward on this")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("planet for the individual being,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and You are the one who granted it.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Our gratitude for this,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and may your blessings shower upon us")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to make us healthy, happy, and holy")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and may we live in a raised consciousness of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("universal consciousness of love, peace, and harmony.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Give us the power to exalt thee.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Give us the power to be thy channel.")]), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('big', [_vm._v("I")]), _vm._v(" arise each day")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Through the strength of heaven:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Light of sun,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Radiance of moon,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Splendor of fire,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Speed of lightening,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Swiftness of wind,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Depth of sea,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Stability of earth,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Firmness of rock.")]), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('big', [_vm._v("H")]), _vm._v("ow would it be")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("if just for today")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("we thought less about contests and rivalries,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("profits and politics,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("winners and sinners,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and more about")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("helping and giving,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("mending and blending,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("reaching out")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and pitching in?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("How would it be?")]), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("T")]), _vm._v("he birds have vanished into the sky,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and now the last cloud drains away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We sit together, the mountain and me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Until only the mountain remains.")]), _vm._v(" "), _vm._m(76), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('big', [_vm._v("H")]), _vm._v("ail, hail, hail")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May happiness come.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May meat come,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May corn come.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Just as the farmers work")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And look forward to the reaping,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("So may we sit again as we are sitting now.")]), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("L")]), _vm._v("et us all resolve: First to attain the grace of silence; Second to deem all fault-finding that does no good a sin . . . Third to practice the grace and virtue of praise.")], 1), _vm._v(" "), _vm._m(79), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('big', [_vm._v("O")]), _vm._v("ne does not need to fast for days and meditate for hours at a time to experience the sense of sublime mystery which constantly envelops us. All one need do is notice intelligently, if even for a brief moment, a blossoming tree, a forest flooded with autumn colors, an infant smiling.")], 1), _vm._v(" "), _vm._m(81), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("I")]), _vm._v(" have a dream today.")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("I have a dream that one day every valley shall be")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("exalted, every hill and mountain shall be made low, the")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("rough places will be made plain,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and the crooked places shall be made straight,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and the glory of the Lord shall be revealed, and")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("all flesh shall see it together.")]), _vm._v(" "), _vm._m(82), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('big', [_vm._v("I")]), _vm._v(" want to be your friend")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("For ever and ever without break or decay.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When the hills are all flat")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And the rivers are all dry,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When it lightens and thunders in winter,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When it rains and snows in summer,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When Heaven and Earth mingle—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Not till then will I part from you.")]), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("A")]), _vm._v("ttend me, hold me in your muscular flowering arms, protect me from throwing any part of myself away.")], 1), _vm._v(" "), _vm._m(85), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(86), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('big', [_vm._v("B")]), _vm._v("e at peace with your own soul, then heaven and earth will be at peace with you. Enter eagerly into the treasure house that is within you, you will see the things that are in heaven; for there is but one single entry to them both. The ladder that leads to the Kingdom is hidden within your soul . . . Dive into yourself, and in your soul you will discover the stairs by which to ascend.")], 1), _vm._v(" "), _vm._m(87), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("W")]), _vm._v("ith grateful hearts the past we own;")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The future, all to us unknown,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We to Thy guardian care commit,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And peaceful leave before Thy feet.")]), _vm._v(" "), _vm._m(88), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('big', [_vm._v("A")]), _vm._v("m I acting in simplicity, from a germ of the Divine life within, or am I shaping my path to obtain some immediate result of expediency? Am I endeavoring to compass effects, amidst a tangled web of foreign influences I cannot calculate; or am I seeking simply to do what is right, and leaving the consequences to the good providence of God?")], 1), _vm._v(" "), _vm._m(89), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("N")]), _vm._v("ot for the mighty world, O Lord, tonight,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("nations and kingdoms in their fearful might—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let me be glad the kettle gently sings,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("let me be glad for little things.")]), _vm._v(" "), _vm._m(90), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(91), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("he sun brings forth the beginning")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The moon holds it in darkness")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("As above, so below")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("For there is no greater magic in all the world")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("than that of people joined together in love.")]), _vm._v(" "), _vm._m(92), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(93), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("W")]), _vm._v("hose hand is this")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("that has never died?")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Who is it who was born in the past?")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Who is it who will die in the future?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("If you look deeply into the palm of your hand, you will")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("see your parents and all generations of your ancestors.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("All of them are alive in this moment . . . Previous")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("generations, all the way back to single-celled beings,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("are present in your hand at this moment.")]), _vm._v(" "), _vm._m(94), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('big', [_vm._v("I")]), _vm._v(" have perceiv'd that to be with")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("those I like is enough,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To stop in company with the rest")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("at evening is enough,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To be surrounded by beautiful, curious, breathing,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("laughing flesh is enough.")]), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("Y")]), _vm._v("ou spent the first half of your life becoming somebody. Now you can work on becoming nobody, which is really somebody. For when you become nobody there is no tension, no pretense, no one trying to be anyone or anything. The natural state of the mind shines through unobstructed—and the natural state of the mind is pure love.")], 1), _vm._v(" "), _vm._m(97), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(98), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("hankful may I ever be for everything that")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("God bestows.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Thankful for the joys and sorrows, for the blessings")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and the blows.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Thankful for the wisdom gained through")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("hardships and adversity.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Thankful for the undertones as well as for the")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("melody.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Thankful may I ever be for benefits both")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("great and small—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and never fail in gratitude for that divinest gift")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("of all:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the love of friends that I have known in times of")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("failures and success.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("O may the first prayer of the day be always one of")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("thankfulness.")]), _vm._v(" "), _vm._m(99), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('big', [_vm._v("O")]), _vm._v("h, come to the water all you who are thirsty;")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("though you have no money, come!")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Buy corn without money, and eat,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and, at no cost, wine and milk.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Why spend money on what is not bread,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("your wages on what fails to satisfy?")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Listen, listen to me, and you will have good things to")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("eat and rich food to enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Pay attention, come to me;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("listen, and your soul will live.")]), _vm._v(" "), _vm._m(100), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(101), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('big', [_vm._v("I")]), _vm._v("nasmuch as the great Father has given us this year an abundant harvest of Indian corn, wheat, beans, squashes, and garden vegetables, and has made the forests to abound with game and the sea with fish and clams, and inasmuch as He . . . has spared us from pestilence and disease, has granted us freedom to worship God according to the dictates of our own conscience; now, I, your magistrate, do proclaim that all ye Pilgrims, with your wives and little ones, do gather at ye meeting house, on ye hill, between the hours of 9 and 12 in the day time, on Thursday, November 29th of the year of our Lord one thousand six hundred and twenty-three, and the third year since ye Pilgrims landed on ye Pilgrim Rock, there to listen to ye pastor, and render thanksgiving to ye Almighty God for all His blessings.")], 1), _vm._v(" "), _vm._m(102), _vm._v(" "), _vm._m(103), _vm._v(" "), _vm._m(104), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('big', [_vm._v("G")]), _vm._v("ive us thankful hearts . . . in this the season of Thy Thanksgiving. May we be thankful for health and strength, for sun and rain and peace. Let us seize the day and the opportunity and strive for that greatness of spirit that measures life not by its disappointments but by its possibilities, and let us ever remember that true gratitude and appreciation shows itself neither in independence nor satisfaction but passes the gift joyfully on in larger and better form.")], 1), _vm._v(" "), _vm._m(105), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("C")]), _vm._v("ome, ye thankful people, come.")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Raise the song of harvest home;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("All is safely gathered in,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Ere the winter storms begin.")]), _vm._v(" "), _vm._m(106), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(107), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("he reality that is present to us and in us:")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("call it Being . . . Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And the simple fact that by being attentive,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("by learning to listen")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("(or recovering the natural capacity to listen)")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("we can find ourself engulfed in such happiness")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("that it cannot be explained:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the happiness of being at one with everything")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in that hidden ground of Love")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("for which there can be no explanations . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May we all grow in grace and peace,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and not neglect the silence that is printed")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in the centre of our being.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It will not fail us.")]), _vm._v(" "), _vm._m(108), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("M")]), _vm._v("ake a [silent] prayer acknowledging yourself as a vehicle of light, giving thanks for all that has come today.")], 1), _vm._v(" "), _vm._m(109), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("he great sea")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Has sent me adrift")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It moves me")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("As the weed in a great river")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Earth and the great weather")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Move me")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Have carried me away")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And move my inward parts with joy.")]), _vm._v(" "), _vm._m(110), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("B")]), _vm._v("less these Thy gifts, most gracious God,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("From whom all goodness springs;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Make clean our hearts and feed our souls")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("With good and joyful things.")]), _vm._v(" "), _vm._m(111), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(112), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('big', [_vm._v("L")]), _vm._v("ove means to love that which is unlovable,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("or it is no virtue at all;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("forgiving means to pardon the unpardonable,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("or it is no virtue at all;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("faith means believing the unbelievable,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("or it is no virtue at all;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And to hope means hoping when things are hopeless,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("or it is no virtue at all.")]), _vm._v(" "), _vm._m(113), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("W")]), _vm._v("ith the first mouthful, I promise to practice")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("loving kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("With the second, I promise to help relieve the")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("suffering of others.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("With the third, I promise to see others' joy as my")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("own.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("With the fourth, I promise to learn the way of nonattachment")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and equanimity.")]), _vm._v(" "), _vm._m(114), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('big', [_vm._v("M")]), _vm._v("ost gracious Spirit, by whose knowledge the depths are broken up, and the clouds drop down the dew; we yield thee unfeigned thanks and praise for the return of seed-time and harvest, for the increase of the ground and the gathering in of the fruits thereof, and for all the other blessings bestowed upon us.")], 1), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("M")]), _vm._v("ay all things move and be moved in me")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and know and be known in me")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May all creation")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("dance for joy within me")]), _vm._v(" "), _vm._m(117), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(118), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('big', [_vm._v("F")]), _vm._v("riend, is sugar sweeter or He who makes the sugar?")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Friend, is the moon fairer or He who makes the")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("moon?")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Forgo sugars, forgo moons; He knows something")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("other, He makes something other.")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("In the sea are marvels besides pearls, but none like")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the Monarch who makes the sea and the pearls.")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Beside the water is another water springing from a")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("marvelous waterwheel; without flaw and unsleeping It")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("provides sustenance to the heart.")]), _vm._v(" "), _vm._m(119), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("I")]), _vm._v(" move through my day-to-day life with a sense of appreciation and gratitude that comes from knowing how fortunate I truly am and how unearned all that I am thankful for really is. To have this perspective in my everyday consciousness is in itself a gift, for it leads to feeling “graced,” or blessed, each time.")], 1), _vm._v(" "), _vm._m(120), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('big', [_vm._v("E")]), _vm._v("ach day I learn more than I teach;")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I learn that half knowledge of another's life")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Leads to false judgment;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I learn that there is a surprising kinship")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("In human nature;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I learn that it is a wise father who knows his son;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I learn that what we expect we get;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I learn that there's more good than evil")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("in this world;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("That age is a question of spirit;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("That youth is the best of life")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("No matter how numerous its years;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I learn how much there is to learn.")]), _vm._v(" "), _vm._m(121), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(122), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('big', [_vm._v("G")]), _vm._v("ive all to love;")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Obey thy heart;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Friends, kindred, days,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Estate, good fame,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Plans, credit and the Muse,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Nothing refuse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("'Tis a brave master;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let it have scope:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Follow it utterly,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Hope beyond hope:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("High and more high")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It dives into noon,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("With wing unspent,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Untold intent;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("But it is a god,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Knows its own path,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And the outlets of the sky.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It was never for the mean;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It requireth courage stout,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Souls above doubt,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Valour unbending:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Such 'twill reward;")]), _vm._v(" "), _vm._m(123), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("More than they were,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and ever ascending . . .")]), _vm._v(" "), _vm._m(124), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("I")]), _vm._v(" aint what I wana be")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I aint what I'm gona be")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but Oh Lord")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I aint what I used to be.")]), _vm._v(" "), _vm._m(125), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(126), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('big', [_vm._v("T")]), _vm._v("ouch the world from the place centered in the heart and remain the selfless bearer of truth.")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Beckon not self-serving illusions to fill the void of time and space, but reach to the core to produce a reality of the one vision of hope.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Come to the world with an openness of heart and lay to rest the falsehood of desire, the fear of wanting, and the futility of pursuit.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Live in Spirit's Will and all will be fulfilled through the pure power of Creation. All will be, beyond your imaginings.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Claim the Light that is yours to bear and carry the lantern of love into the darkened world of illusions.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Perceive not Spirit's plan, but go into the joy of the now. All will come to pass in perfect harmony if you but believe it is so.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Go in the peace that the moment is now.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Go in love, for that is what you are.")]), _vm._v(" "), _vm._m(127), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('big', [_vm._v("E")]), _vm._v("l Shaddai [translated from the Hebrew as breasted")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("god],")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You are the earth beneath our feet,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the ground of our being,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and the Womb of all.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You birth the earth,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("groaning with great labor pain in all our suffering")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and dying.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Your golden joys and scarlet sorrows")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("fall onto death's dark soil,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and nourish the grain that becomes the Bread of")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Life.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We harvest Your bounty,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("we feast on Your beauty,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and are nourished and comforted at the breasts of")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Your goodness.")]), _vm._v(" "), _vm._m(128), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(129), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('big', [_vm._v("O")]), _vm._v(" Thou in whose great arms")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("All the children of earth are embraced,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Here in thy presence we remember")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("our kinship with all human kind.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We rejoice for those who are in")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("full health and strength,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Whose ways are ways of pleasantness")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("and peace.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Our hearts reach out toward those")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("whose ways are ways of suffering,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("of body, mind, or soul.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May it be that thou shalt find us")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("reaching out to them")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Not only with our hearts but with")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("our hands also,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To help them in the bearing of")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("their burdens,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To help in the lifting of their")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("burdens.")]), _vm._v(" "), _vm._m(130), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('big', [_vm._v("M")]), _vm._v("ay all beings have happiness and the causes of happiness;")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("this is immeasurable loving kindness;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May all beings be liberated from suffering and the causes of suffering;")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("this is immeasurable compassion;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May all beings be free of suffering and always stay happy;")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("this is immeasurable joy;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May all beings be free of grasping and aversion towards others, and develop faith in the equality of all beings;")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("this is immeasurable equanimity.")]), _vm._v(" "), _vm._m(131), _vm._v(" "), _vm._m(132), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(133), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('big', [_vm._v("I")]), _vm._v("t is love that fashions us into the fullness of our being—not our looks, not our work, not our wants, not our achievements, not our parents, not our status, not our dreams. These all are the fodder and the filler, the navigating fuels of our lives; but it is love: who we love, how we love, why we love, and that we love which ultimately shapes us.")], 1), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("It is love, before all and after all, in the beginning and in the end, that creates us. Today, remembering this, let yourself acknowledge and remember the moments, events, and people who bring you, even momentarily, into a true experience of love, and allow the rest, the inescapable mundanities of life, like a cloud, to very quietly drift away.")]), _vm._v(" "), _vm._m(134), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('big', [_vm._v("M")]), _vm._v("ay beings all live happily and safe")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And may their hearts rejoice within themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Whatever there may be with breath of life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Whether they be frail or very strong,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Without exception, be they long or short")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Or middle-sized, or be they big or small,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Or thick, or visible, or invisible,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Or whether they dwell far or they dwell near,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Those that are here, those seeking to exist—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May beings all rejoice within themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let no one bring about another's ruin")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And not despise in any way or place,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Let them not wish each other any ill")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("From provocation or from enmity.")]), _vm._v(" "), _vm._m(135), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(136), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("e watch the water falling.")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It looks just like a man")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("At the moment he says")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I do at a ceremony")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("That the water, still so long")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Doesn't fully understand")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Or agree with.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We see fire that is hungrier")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Than any workman wanting")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dinner after a hard day's labor.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It gobbles up everything.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In both worlds and refuses")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To go out no matter how much")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Rain it receives.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Being told “Good morning, would")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You like tea or coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("By a friend that watches water,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Loves fire, and other sacred")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Ordinary moments, and scenes")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Is like a visit to the rim of a")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Canyon. We're not exactly sure")]), _vm._v(" "), _vm._m(137), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("To simply stare and weep.")]), _vm._v(" "), _vm._m(138), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("G")]), _vm._v("ratitude before me,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude behind me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude to the left of me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude to the right of me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude above me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude below me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude within me,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("gratitude all around me.")]), _vm._v(" "), _vm._m(139), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(140), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('big', [_vm._v("W")]), _vm._v("ho loves the rain,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("And loves his home,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And looks on life with quiet eyes,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Him will I follow through the storm,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("And at his hearth-fire keep me warm;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Nor hell nor heaven shall that soul surprise")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Who loves the rain,")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("And loves his home,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And looks on life with quiet eyes.")]), _vm._v(" "), _vm._m(141), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('big', [_vm._v("O")]), _vm._v(" Hidden Life, vibrant in every atom,")], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("O Hidden Light, shining in every creature,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("O Hidden Love, embracing all in Oneness,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("May we each who feels himself as one with Thee")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Know he is therefore one with every other.")]), _vm._v(" "), _vm._m(142), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('big', [_vm._v("F")]), _vm._v("ather-Mother of the Universe, in the beauty of Your Presence we give thanks for family and friends and for the clan of man. Nourish our bodies with these gifts of the earth and our minds with the thoughts sparkling among us. We will that our personal will be in atonement with the Divine as our Spirits bow in awe and wonder of the Great Unseen.")], 1), _vm._v(" "), _vm._m(143), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _vm._m(144)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "fall"
    }
  }), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "blockquotecenter"
  }, [_c('i', [_vm._v("Gratitude is heaven itself.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "blockquotecenter"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAKE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORGE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERBERT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDDHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APHNE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGMA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("That You are in me,")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERALD")]), _vm._v(" G. J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPOLSKY")]), _vm._v(", M.D.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNABELLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OODARD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAPTED FROM")]), _vm._v(" "), _c('i', [_vm._v("The Book of")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Common Prayer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSH")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASHANAH LITURGY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNG")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("We join with the earth and with each other")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—U.N. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVIRONMENTAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABBATH")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROGRAM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 23:1, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADAPTED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RADITIONAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISH BLESSING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMI")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRANSLATED BY")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EILHARD DE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARDIN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERI")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULME")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LISABETH")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÜBLER")]), _vm._v("-R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("So When Life Fades, as the fading sunset,")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIVE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN PRAYER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—W. E. B. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("U")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OIS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADDISH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADAPTED FROM A SPEECH BY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LATO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JIBWAY PEOPLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANADA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADAPTED PRAYER FROM")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEK OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE")]), _vm._v(", 1978")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILDEGARD OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGEN")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRANSLATED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITCHELL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNETT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN CHANT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENCH")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENISE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERTOV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVI")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITCHAK OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDITSCHEV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("The Star of Joy")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACRINA")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEDERKEHR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESLEY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERESA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" "), _c('i', [_vm._v("Workbook for Spiritual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Development of All People, p. 180")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESHAD")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EILD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAHERNE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICH")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANNIE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERRON")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGATE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_vm._v("Its essence is "), _c('i', [_vm._v("vishnu")]), _vm._v(" (preservative energy)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_vm._v("The eater is "), _c('i', [_vm._v("shiva")]), _vm._v(" (destructive energy)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANSKRIT BLESSING")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRANSLATED BY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABA")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARI")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER TO THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTAIN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('i', [_vm._v("Mahanirvana Tantra X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGI")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAJAN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADAPTED FROM AN EARLY")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISH SONG")]), _vm._v(",")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ATTRIBUTED TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRICK")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("I")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER OF THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTIVAL")]), _vm._v(",")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRIET")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EECHER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TOWE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMON")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REENBERG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CENTURY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINESE OATH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("OF FRIENDSHIP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDRE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SACC OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INEVEH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODDRIDGE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—M. A. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHIMMELPENNINCK")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DNA")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AQUES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICCAN BLESSING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('i', [_vm._v("To be said looking at your hand:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICH")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITMAN")]), _vm._v(", “I S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LECTRIC")]), _vm._v("”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIENCE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRONG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SAIAH")]), _vm._v(" 55:1-11")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RADFORD")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOVERNOR OF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LYMOUTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLONY")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANKSGIVING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PROCLAMATION")]), _vm._v(", 1623")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—W. E. B. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("U")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OIS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENRY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LFORD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HYANI")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAHOO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VAVNUK")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SKIMO SHAMAN WOMAN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RADITIONAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN GRACE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—G. K. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESTERTON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICH")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAPTED FROM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINOOK")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALTER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMI")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRANSLATED BY")]), _vm._v(" A. J. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RBERRY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINODA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRGINIA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("They shall return")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALPH")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALDO")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERSON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR OF")]), _vm._v(" "), _c('i', [_vm._v("An Unknown Slave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IANE")]), _vm._v(" V. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRINCIONE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS TWENTIETH")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CENTURY PRAYER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENCH")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MMEASURABLE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWS")]), _vm._v(",")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANTRIC")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDDHISM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APHNE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGMA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDDHA")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTTA")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPATA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("Whether to jump, to fly or")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVY")]), _vm._v(", “W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATCHING")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIENDSHIP")]), _vm._v("”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGELES")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RRIEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANCIS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAW")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNIE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESANT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNABELLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OODARD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fall.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f75112","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_fall.vue
// module id = 75
// module chunks = 0